import styled from "styled-components";
import {Button, DialogTitle, FormControl, IconButton, Stack, Typography} from "@mui/material";

export const FilterContainer = styled.div`
  display: flex;
  align-items: center;
  padding: 2px 4px;
  border-radius: 6px;
`;

export const ButtonFilter = styled(Button)`
&&{
  height: 35px;
  width: 90px;
  min-width: 90px;
  border: 1px solid #000000;
  border-radius : 6px;
  margin-right: 8px;
}`;

export const IconButtonFilter = styled(IconButton)`
  padding: 6px;
`;

export const TypographyFilter = styled(Typography)`
  color: #000000;
  text-align: center;
  font-size: 12px;
`;

export const StyledStack = styled(Stack)`
  width: 100%;
`;

export const StyledDivFilter = styled.div`
    padding: 0px 16px;
    width: 590px;
    height: 50px;
    border-radius: 5px;
    display: flex;
`;

export const StyledButtonFilter = styled.div`
    padding: 15px;
    text-align: right;
`;

export const StackFilter = styled(Stack)`
  width: 170px;
  margin: 8px;
`;

export const FormControlFilter = styled(FormControl)`
  min-width: 170px;
  margin: 8px;
`;

export const DialogTitleFilter = styled(DialogTitle)`
  padding: 16px 24px;
`;
